/**
 * Shared button styles for MuseIQ Lit components.
 * Mirrors the global .btn rules from styles.css for use inside shadow DOM.
 */
import { css } from 'lit';

export const buttonStyles = css`
    .btn {
        display: inline-block;
        padding: 0.75rem 1.5rem;
        font-size: 1rem;
        font-weight: 600;
        text-align: center;
        border: none;
        border-radius: 0.5rem;
        cursor: pointer;
        transition: all 0.2s;
        font-family: inherit;
        -webkit-user-select: none;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
    }

    .btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .btn-primary {
        background-color: var(--primary-color, #2563eb);
        color: white;
    }

    .btn-primary:hover:not(:disabled) {
        background-color: var(--primary-dark, #1e40af);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px var(--shadow, rgba(0, 0, 0, 0.5));
    }

    .btn-secondary {
        background-color: var(--secondary-color, #64748b);
        color: white;
    }

    .btn-secondary:hover:not(:disabled) {
        background-color: var(--surface-light, #334155);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px var(--shadow, rgba(0, 0, 0, 0.5));
    }

    .btn-danger {
        background-color: var(--danger-color, #dc2626);
        color: white;
    }

    .btn-danger:hover:not(:disabled) {
        background-color: #b91c1c;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px var(--shadow, rgba(0, 0, 0, 0.5));
    }

    .btn-outline {
        background: transparent;
        border: 1px solid var(--border, #475569);
        color: var(--text-primary, #f1f5f9);
    }

    .btn-outline:hover:not(:disabled) {
        background: var(--surface-light, #334155);
    }
`;
